export const getTimeline = state => state.timeline.data;
export const getError = state => state.timeline.error;